export { default } from "./PlayerDetailCenterContainer";
